import { WaterfallFilterStorage, WaterfallFilterType, waterfallDateFilterProcessor } from '@bingads-webui-campaign/filter-storage';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { PreferenceContext } from '@bingads-webui-react/preference-context';
import { useContext } from 'react';
import kendo from '@bingads-webui/kendo/kendo.core';

// date-filter plugin and related logic is in "projection-grid-date-filter/src/plugin.js"

const formatDateInEntitySet = date => kendo.toString(date, 'yyyy-MM-dd');
const parseDate = dateString => kendo.parseDate(dateString);

function useDateRangeDefault() {
  const preferenceService = useContext(PreferenceContext);
  const serverContext = useContext(ServerContext);
  const waterfallFilterStorage = new WaterfallFilterStorage({
    preferenceService,
  });
  const waterFallDateFilters = waterfallFilterStorage.getFilters([WaterfallFilterType.DateFilter]);
  const dateFilter = waterfallDateFilterProcessor(waterFallDateFilters, serverContext);
  return dateFilter;
}

export function useP$DaterangeDefault() {
  const dateFilter = useDateRangeDefault();
  return Promise.resolve(dateFilter);
}

// What about comparison date range?
// Listing Gruop page does not have comparison date range
export function useDateRange() {
  const dateRange = useDateRangeDefault();
  return {
    StartDate: formatDateInEntitySet(dateRange.start) ||
      formatDateInEntitySet(parseDate(dateRange.RangeStartDate)),
    EndDate: formatDateInEntitySet(dateRange.end) ||
      formatDateInEntitySet(parseDate(dateRange.RangeEndDate)),
  };
}
